module.exports = __webpack_public_path__ + "4cd9a5350f97c308f2454a8b92e3243e.png";